import Accordion from "react-bootstrap/Accordion";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { GeoAlt, Calendar3 } from "react-bootstrap-icons";

import "./CustomAccordion.css";

const DetailButtonItem = ({ icon, text }) => (
  <div className="d-flex align-items-center gap-2">
    <Nav.Item>
      <Nav.Link className="square-button">{icon}</Nav.Link>
    </Nav.Item>
    <p className="accordion__duration">{text}</p>
  </div>
);

const jobs = [
  { key: "job0", taskCount: 2 },
  { key: "job1", taskCount: 3 },
  { key: "job2", taskCount: 4 },
  { key: "job3", taskCount: 3 },
];

export const CustomAccordion = () => {
  const { t } = useTranslation();

  return (
    <Accordion defaultActiveKey="0">
      {jobs.map((job, index) => (
        <Accordion.Item eventKey={String(index)} key={index}>
          <Accordion.Header>
            {t(`experience.${job.key}.title`)}
          </Accordion.Header>
          <Accordion.Body>
            <div className="m-3">
              <Nav className="gap-3 ">
                <DetailButtonItem
                  icon={<Calendar3 size="1rem" />}
                  text={t(`experience.${job.key}.date`)}
                />
                <DetailButtonItem
                  icon={<GeoAlt size="1rem" />}
                  text={t(`experience.${job.key}.location`)}
                />
              </Nav>
            </div>
            <ul className="accordion__list">
              {Array.from({ length: job.taskCount }, (_, i) => (
                <li key={i}>{t(`experience.${job.key}.task${i}`)}</li>
              ))}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};
